package br.com.vvrefeicoes.portal.feature.guides

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.rememberScrollState
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.DropdownMenu
import androidx.compose.material3.DropdownMenuItem
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.FilterChip
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.material3.Switch
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.SideEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.key
import androidx.compose.runtime.mutableStateMapOf
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.vector.rememberVectorPainter
import androidx.compose.ui.platform.LocalClipboardManager
import androidx.compose.ui.text.AnnotatedString
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import br.com.vvrefeicoes.portal.core.di.rememberSessionPermissions
import br.com.vvrefeicoes.portal.core.ui.components.AppBanner
import br.com.vvrefeicoes.portal.core.ui.components.AppButton
import br.com.vvrefeicoes.portal.core.ui.components.AppFooter
import br.com.vvrefeicoes.portal.core.ui.components.AppModalCard
import br.com.vvrefeicoes.portal.core.ui.components.AppTextField
import br.com.vvrefeicoes.portal.core.ui.components.AppToast
import br.com.vvrefeicoes.portal.core.ui.components.AppTooltipIconButton
import br.com.vvrefeicoes.portal.core.ui.components.EmptyState
import br.com.vvrefeicoes.portal.core.ui.components.PortalButtonVariant
import br.com.vvrefeicoes.portal.core.ui.components.SuccessDialog
import br.com.vvrefeicoes.portal.core.ui.layout.AppScrollColumn
import br.com.vvrefeicoes.portal.core.ui.layout.appLayoutMetrics
import br.com.vvrefeicoes.portal.core.ui.theme.AppPalette
import br.com.vvrefeicoes.portal.core.ui.theme.AppShapes
import br.com.vvrefeicoes.portal.core.ui.theme.AppSpacing
import br.com.vvrefeicoes.portal.core.util.file.isPdfUploadSupported
import br.com.vvrefeicoes.portal.core.util.file.isVideoUploadSupported
import br.com.vvrefeicoes.portal.core.util.file.pickPdfFile
import br.com.vvrefeicoes.portal.core.util.file.pickVideoFile
import br.com.vvrefeicoes.portal.core.util.guideShareLink
import br.com.vvrefeicoes.portal.core.util.image.isImageUploadSupported
import br.com.vvrefeicoes.portal.core.util.image.pickImageFile
import br.com.vvrefeicoes.portal.core.util.toPdfImage
import br.com.vvrefeicoes.portal.domain.model.Guide
import br.com.vvrefeicoes.portal.domain.model.GuideBlock
import br.com.vvrefeicoes.portal.domain.model.GuideBlockType
import br.com.vvrefeicoes.portal.domain.model.GuideContentType
import br.com.vvrefeicoes.portal.domain.model.GuideStatus
import br.com.vvrefeicoes.portal.domain.model.GuideSummary
import br.com.vvrefeicoes.portal.domain.model.PermissionAction
import br.com.vvrefeicoes.portal.domain.model.PermissionKeys
import br.com.vvrefeicoes.portal.domain.model.allows
import br.com.vvrefeicoes.portal.feature.notifications.RichBody
import br.com.vvrefeicoes.portal.feature.notifications.RichTextToolbar
import com.composables.icons.lucide.ArrowDown
import com.composables.icons.lucide.ArrowLeft
import com.composables.icons.lucide.ArrowRight
import com.composables.icons.lucide.ArrowUp
import com.composables.icons.lucide.Check
import com.composables.icons.lucide.ChevronDown
import com.composables.icons.lucide.ChevronUp
import com.composables.icons.lucide.Download
import com.composables.icons.lucide.FileText
import com.composables.icons.lucide.Image
import com.composables.icons.lucide.Link
import com.composables.icons.lucide.List
import com.composables.icons.lucide.Lucide
import com.composables.icons.lucide.Paperclip
import com.composables.icons.lucide.Pencil
import com.composables.icons.lucide.Play
import com.composables.icons.lucide.Plus
import com.composables.icons.lucide.Search
import com.composables.icons.lucide.Settings
import com.composables.icons.lucide.TextAlignStart
import com.composables.icons.lucide.Trash2
import com.composables.icons.lucide.Video
import com.mohamedrejeb.richeditor.model.LocalImageLoader
import com.mohamedrejeb.richeditor.model.RichTextState
import com.mohamedrejeb.richeditor.model.rememberRichTextState
import com.mohamedrejeb.richeditor.ui.material3.RichTextEditor
import com.mohamedrejeb.richeditor.ui.material3.RichTextEditorDefaults
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.jetbrains.compose.resources.painterResource
import portalvv.shared.generated.resources.Res
import portalvv.shared.generated.resources.guides_activated
import portalvv.shared.generated.resources.guides_deactivated
import portalvv.shared.generated.resources.guides_deleted
import portalvv.shared.generated.resources.guides_manual_saved
import portalvv.shared.generated.resources.guides_profiles_saved
import portalvv.shared.generated.resources.guides_saved
import portalvv.shared.generated.resources.logo_portal
import portalvv.shared.generated.resources.logo_vv

@OptIn(ExperimentalLayoutApi::class)
@Composable
fun GuidesAndManualsScreen(
    onOpen: (String) -> Unit,
    onCreate: () -> Unit,
    onEdit: (String) -> Unit,
) {
    val controller = rememberGuidesController()
    val permissions = rememberSessionPermissions()
    val layout = appLayoutMetrics()
    val canCreate = permissions.allows(PermissionKeys.GUIDES_AND_MANUALS, PermissionAction.CREATE)
    val canEdit = permissions.allows(PermissionKeys.GUIDES_AND_MANUALS, PermissionAction.EDIT)
    val canManage = canCreate && canEdit
    val pdfAssets = rememberGuidePdfAssets()
    var collapsedSections by remember { mutableStateOf(setOf<String>()) }
    LaunchedEffect(controller) { controller.init() }
    LaunchedEffect(controller.toast) {
        if (controller.toast != null) {
            delay(2500)
            controller.dismissToast()
        }
    }

    Box(modifier = Modifier.fillMaxSize()) {
        AppScrollColumn(
            modifier = Modifier.fillMaxSize(),
            contentPadding = layout.pagePadding,
            verticalArrangement = Arrangement.spacedBy(layout.pageGap),
            footer = { AppFooter() },
        ) {
            Text(text = "Guias e manuais", style = MaterialTheme.typography.headlineMedium)

            Row(
                modifier = Modifier.fillMaxWidth(),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(AppSpacing.space12),
            ) {
                AppTextField(
                    value = controller.query,
                    onValueChange = controller::updateQuery,
                    placeholder = "Pesquise por título do manual",
                    leadingIcon = { Icon(imageVector = Lucide.Search, contentDescription = null) },
                    modifier = Modifier.weight(1f),
                )
                if (canManage) {
                    AppButton(
                        text = "Criar manual",
                        onClick = onCreate,
                        leadingIcon = Lucide.Plus,
                    )
                }
            }

            controller.errorMessage?.let { message ->
                AppBanner(text = message, onDismiss = controller::dismissError, isError = true)
            }

            when {
                controller.loading && controller.items.isEmpty() ->
                    Box(modifier = Modifier.fillMaxWidth().height(200.dp), contentAlignment = Alignment.Center) {
                        CircularProgressIndicator()
                    }
                controller.items.isEmpty() ->
                    EmptyState(message = "Nenhum manual encontrado.")
                canManage -> {
                    val drafts = controller.items.filter { it.status == GuideStatus.RASCUNHO }
                    val published = controller.items.filter { it.status == GuideStatus.PUBLICADO && it.active }
                    val legacy = controller.items.filter { it.status == GuideStatus.PUBLICADO && !it.active }
                    val sections =
                        listOf(
                            "Rascunho" to drafts,
                            "Publicado" to published,
                            "Legado" to legacy,
                        ).filter { it.second.isNotEmpty() }

                    Column(verticalArrangement = Arrangement.spacedBy(layout.pageGap)) {
                        sections.forEach { (title, items) ->
                            GuideSection(
                                title = title,
                                items = items,
                                expanded = title !in collapsedSections,
                                canManage = canManage,
                                toggling = controller.toggling,
                                onToggleExpanded = {
                                    collapsedSections =
                                        if (title in collapsedSections) {
                                            collapsedSections - title
                                        } else {
                                            collapsedSections + title
                                        }
                                },
                                onOpen = onOpen,
                                onEdit = onEdit,
                                onToggleRequest = controller::requestToggle,
                                onDownloadPdf = { id -> controller.downloadPdf(id, pdfAssets()) },
                            )
                        }
                    }
                }
                else -> {
                    GuideGrid(
                        items = controller.items.filter { it.status == GuideStatus.PUBLICADO && it.active },
                        canManage = false,
                        toggling = false,
                        onOpen = onOpen,
                        onEdit = onEdit,
                        onToggleRequest = {},
                        onDownloadPdf = { id -> controller.downloadPdf(id, pdfAssets()) },
                    )
                }
            }
        }
        controller.toast?.let { toast ->
            AppToast(
                message =
                    when (toast) {
                        GuideToast.ACTIVATED -> Res.string.guides_activated
                        GuideToast.DEACTIVATED -> Res.string.guides_deactivated
                        GuideToast.DELETED -> Res.string.guides_deleted
                        GuideToast.PROFILES_SAVED -> Res.string.guides_profiles_saved
                    },
                modifier = Modifier.align(Alignment.BottomCenter).padding(bottom = AppSpacing.space24),
            )
        }
    }

    controller.toggleTarget?.let { target ->
        val activating = !target.active
        AppModalCard(
            title = if (activating) "Ativar manual" else "Inativar manual",
            onDismiss = controller::dismissToggle,
        ) {
            Text(
                text =
                    if (activating) {
                        "Deseja ativar este manual e disponibilizá-lo novamente para os usuários?"
                    } else {
                        "Deseja inativar este manual? Ele será movido para Legado e ficará visível apenas para gestores."
                    },
            )
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8, Alignment.End),
            ) {
                AppButton(
                    text = "Cancelar",
                    onClick = controller::dismissToggle,
                    variant = PortalButtonVariant.Text,
                )
                AppButton(
                    text = if (activating) "Ativar" else "Inativar",
                    onClick = controller::confirmToggle,
                    enabled = !controller.toggling,
                    variant = if (activating) PortalButtonVariant.Filled else PortalButtonVariant.Danger,
                )
            }
        }
    }
}

@Composable
private fun GuideSection(
    title: String,
    items: List<GuideSummary>,
    expanded: Boolean,
    canManage: Boolean,
    toggling: Boolean,
    onToggleExpanded: () -> Unit,
    onOpen: (String) -> Unit,
    onEdit: (String) -> Unit,
    onToggleRequest: (GuideSummary) -> Unit,
    onDownloadPdf: (String) -> Unit,
) {
    val layout = appLayoutMetrics()
    Column(verticalArrangement = Arrangement.spacedBy(layout.cardGap)) {
        Row(
            modifier = Modifier.fillMaxWidth().clickable(onClick = onToggleExpanded).padding(vertical = AppSpacing.space4),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(AppSpacing.space12),
        ) {
            Icon(
                imageVector = if (expanded) Lucide.ChevronUp else Lucide.ChevronDown,
                contentDescription = null,
                tint = MaterialTheme.colorScheme.onSurfaceVariant,
                modifier = Modifier.size(20.dp),
            )
            Text(
                text = title,
                style = MaterialTheme.typography.titleMedium,
                fontWeight = FontWeight.SemiBold,
            )
        }
        if (expanded) {
            GuideGrid(
                items = items,
                canManage = canManage,
                toggling = toggling,
                onOpen = onOpen,
                onEdit = onEdit,
                onToggleRequest = onToggleRequest,
                onDownloadPdf = onDownloadPdf,
            )
        }
    }
}

@Composable
private fun GuideGrid(
    items: List<GuideSummary>,
    canManage: Boolean,
    toggling: Boolean,
    onOpen: (String) -> Unit,
    onEdit: (String) -> Unit,
    onToggleRequest: (GuideSummary) -> Unit,
    onDownloadPdf: (String) -> Unit,
) {
    val layout = appLayoutMetrics()
    androidx.compose.foundation.layout.BoxWithConstraints(modifier = Modifier.fillMaxWidth()) {
        val columns =
            when {
                maxWidth < 680.dp -> 1
                maxWidth < 1080.dp -> 2
                else -> 3
            }
        Column(verticalArrangement = Arrangement.spacedBy(layout.cardGap)) {
            items.chunked(columns).forEach { rowItems ->
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.spacedBy(layout.cardGap),
                    verticalAlignment = Alignment.Top,
                ) {
                    rowItems.forEach { item ->
                        GuideCard(
                            summary = item,
                            canManage = canManage,
                            toggling = toggling,
                            onOpen = { onOpen(item.id) },
                            onEdit = { onEdit(item.id) },
                            onToggleRequest = { onToggleRequest(item) },
                            onDownloadPdf = { onDownloadPdf(item.id) },
                            modifier = Modifier.weight(1f),
                        )
                    }
                    repeat(columns - rowItems.size) {
                        Spacer(modifier = Modifier.weight(1f))
                    }
                }
            }
        }
    }
}

@Composable
private fun GuideCard(
    summary: GuideSummary,
    canManage: Boolean,
    toggling: Boolean,
    onOpen: () -> Unit,
    onEdit: () -> Unit,
    onToggleRequest: () -> Unit,
    onDownloadPdf: () -> Unit,
    modifier: Modifier = Modifier,
) {
    val layout = appLayoutMetrics()
    val clipboard = LocalClipboardManager.current
    Surface(
        modifier = modifier.fillMaxWidth(),
        shape = AppShapes.large,
        color = MaterialTheme.colorScheme.surface,
        border = BorderStroke(1.dp, MaterialTheme.colorScheme.outlineVariant),
    ) {
        Column(
            modifier = Modifier.fillMaxWidth().padding(layout.cardPadding),
            verticalArrangement = Arrangement.spacedBy(layout.cardGap),
        ) {
            Surface(
                modifier = Modifier.fillMaxWidth().height(120.dp),
                shape = AppShapes.medium,
                color = typeBackground(summary.contentType),
            ) {
                Box(contentAlignment = Alignment.Center) {
                    Icon(
                        imageVector = typeIcon(summary.contentType),
                        contentDescription = null,
                        tint = typeColor(summary.contentType),
                        modifier = Modifier.size(40.dp),
                    )
                }
            }

            Column(verticalArrangement = Arrangement.spacedBy(AppSpacing.space4)) {
                Text(
                    text = summary.title,
                    style = MaterialTheme.typography.titleMedium,
                    fontWeight = FontWeight.SemiBold,
                    maxLines = 2,
                    overflow = TextOverflow.Ellipsis,
                )
                summary.version?.let { version ->
                    Text(
                        text = "v$version",
                        style = MaterialTheme.typography.labelMedium,
                        color = MaterialTheme.colorScheme.onSurfaceVariant,
                    )
                }
            }

            if (summary.excerpt.isNotBlank()) {
                Text(
                    text = summary.excerpt,
                    style = MaterialTheme.typography.bodyMedium,
                    color = MaterialTheme.colorScheme.onSurfaceVariant,
                    maxLines = 2,
                    overflow = TextOverflow.Ellipsis,
                )
            }

            summary.createdByName?.takeIf { it.isNotBlank() }?.let { createdBy ->
                Text(
                    text = "Criado por $createdBy",
                    style = MaterialTheme.typography.labelSmall,
                    color = MaterialTheme.colorScheme.onSurfaceVariant,
                )
            }
            summary.updatedAt?.takeIf { it.isNotBlank() }?.let { updatedAt ->
                Text(
                    text = "Última alteração em $updatedAt",
                    style = MaterialTheme.typography.labelSmall,
                    color = MaterialTheme.colorScheme.onSurfaceVariant,
                )
            }

            Row(
                modifier = Modifier.fillMaxWidth(),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8),
            ) {
                if (summary.status == GuideStatus.RASCUNHO) {
                    Spacer(modifier = Modifier.weight(1f))
                    GuideLinkAction(text = "Ir para edição", onClick = onEdit)
                } else {
                    if (canManage) {
                        Switch(
                            checked = summary.active,
                            onCheckedChange = { onToggleRequest() },
                            enabled = !toggling,
                        )
                    }
                    AppTooltipIconButton(
                        icon = Lucide.Link,
                        tooltip = "Copiar link",
                        onClick = { clipboard.setText(AnnotatedString(guideShareLink(summary.id))) },
                    )
                    AppTooltipIconButton(
                        icon = Lucide.Download,
                        tooltip = "Baixar PDF",
                        onClick = onDownloadPdf,
                    )
                    Spacer(modifier = Modifier.weight(1f))
                    GuideLinkAction(text = "Ver manual", onClick = onOpen)
                }
            }
        }
    }
}

@Composable
private fun GuideLinkAction(
    text: String,
    onClick: () -> Unit,
) {
    Row(
        modifier = Modifier.clickable(onClick = onClick).padding(vertical = AppSpacing.space8),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8),
    ) {
        Text(
            text = text,
            style = MaterialTheme.typography.labelLarge,
            color = MaterialTheme.colorScheme.primary,
        )
        Icon(
            imageVector = Lucide.ArrowRight,
            contentDescription = null,
            tint = MaterialTheme.colorScheme.primary,
            modifier = Modifier.size(18.dp),
        )
    }
}

@Composable
fun GuideDetailScreen(
    guideId: String,
    onBack: () -> Unit,
    onEdit: (String) -> Unit,
) {
    val controller = rememberGuideDetailController(guideId)
    val permissions = rememberSessionPermissions()
    val canCreate = permissions.allows(PermissionKeys.GUIDES_AND_MANUALS, PermissionAction.CREATE)
    val canEdit = permissions.allows(PermissionKeys.GUIDES_AND_MANUALS, PermissionAction.EDIT)
    val canManage = canCreate && canEdit
    val pdfAssets = rememberGuidePdfAssets()
    val scrollState = rememberScrollState()
    var toast by remember { mutableStateOf<GuideToast?>(null) }

    LaunchedEffect(controller) { controller.init() }
    LaunchedEffect(controller.guide?.id, controller.guide?.status) {
        val guide = controller.guide
        if (guide != null && guide.status == GuideStatus.RASCUNHO) {
            onEdit(guide.id)
        }
    }
    LaunchedEffect(toast) {
        if (toast != null) {
            delay(2500)
            toast = null
        }
    }

    Box(modifier = Modifier.fillMaxSize()) {
        AppScrollColumn(
            modifier = Modifier.fillMaxSize(),
            state = scrollState,
            contentPadding = PaddingValues(AppSpacing.space24),
            verticalArrangement = Arrangement.spacedBy(AppSpacing.space16),
            footer = { AppFooter() },
        ) {
            when {
                controller.loading || controller.guide?.status == GuideStatus.RASCUNHO -> {
                    BackButtonRow(onBack)
                    Box(modifier = Modifier.fillMaxWidth().height(200.dp), contentAlignment = Alignment.Center) {
                        CircularProgressIndicator()
                    }
                }
                controller.errorMessage != null && controller.guide == null -> {
                    BackButtonRow(onBack)
                    Text(text = controller.errorMessage.orEmpty(), color = MaterialTheme.colorScheme.error)
                }
                controller.guide != null -> {
                    val guide = controller.guide!!
                    GuideReadHeader(
                        guide = guide,
                        canManage = canManage,
                        toggling = controller.toggling,
                        onBack = onBack,
                        onToggleActive = { active ->
                            controller.setActive(active) {
                                toast = if (active) GuideToast.ACTIVATED else GuideToast.DEACTIVATED
                            }
                        },
                    )
                    controller.errorMessage?.let { message ->
                        Text(text = message, color = MaterialTheme.colorScheme.error)
                    }
                    GuideReadActions(
                        canManage = canManage,
                        onDownloadPdf = { controller.downloadPdf(guideId, pdfAssets()) },
                        onManageAccess = controller::openAccess,
                        onEdit = { onEdit(guideId) },
                    )
                    Surface(
                        modifier = Modifier.fillMaxWidth(),
                        shape = AppShapes.large,
                        color = MaterialTheme.colorScheme.surface,
                        border = BorderStroke(1.dp, MaterialTheme.colorScheme.outlineVariant),
                    ) {
                        Column(
                            modifier = Modifier.fillMaxWidth().padding(AppSpacing.space16),
                            verticalArrangement = Arrangement.spacedBy(AppSpacing.space24),
                        ) {
                            GuideBlocksContent(
                                blocks = guide.blocks,
                                scrollOffset = scrollState.value,
                                mediaVisible = !controller.accessOpen,
                            )
                        }
                    }
                }
                else -> {
                    BackButtonRow(onBack)
                    EmptyState(message = "Guia não encontrado.")
                }
            }
        }
        toast?.let { current ->
            AppToast(
                message =
                    when (current) {
                        GuideToast.ACTIVATED -> Res.string.guides_activated
                        GuideToast.DEACTIVATED -> Res.string.guides_deactivated
                        GuideToast.DELETED -> Res.string.guides_deleted
                        GuideToast.PROFILES_SAVED -> Res.string.guides_profiles_saved
                    },
                modifier = Modifier.align(Alignment.BottomCenter).padding(bottom = AppSpacing.space24),
            )
        }
    }

    if (controller.accessOpen) {
        ManageAccessDialog(
            controller = controller,
            onProfilesSaved = { toast = GuideToast.PROFILES_SAVED },
        )
    }
}

@Composable
private fun GuideReadHeader(
    guide: Guide,
    canManage: Boolean,
    toggling: Boolean,
    onBack: () -> Unit,
    onToggleActive: (Boolean) -> Unit,
) {
    Column(verticalArrangement = Arrangement.spacedBy(AppSpacing.space8)) {
        Row(
            modifier = Modifier.fillMaxWidth(),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.SpaceBetween,
        ) {
            Row(
                modifier = Modifier.weight(1f),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(AppSpacing.space12),
            ) {
                Text(
                    text = guide.title,
                    style = MaterialTheme.typography.headlineMedium,
                    modifier = Modifier.weight(1f, fill = false),
                )
                if (canManage && guide.status == GuideStatus.PUBLICADO) {
                    Switch(
                        checked = guide.active,
                        onCheckedChange = onToggleActive,
                        enabled = !toggling,
                    )
                }
            }
            AppButton(
                text = "Voltar",
                onClick = onBack,
                variant = PortalButtonVariant.Text,
                leadingIcon = Lucide.ArrowLeft,
            )
        }
        val metadata =
            buildList {
                guide.version?.let { add("v$it") }
                add("Criado por " + (guide.createdByName ?: "Usuário"))
                guide.updatedAt?.let { add("Última alteração em $it") }
            }.joinToString(" · ")
        Text(
            text = metadata,
            style = MaterialTheme.typography.labelMedium,
            color = MaterialTheme.colorScheme.onSurfaceVariant,
        )
    }
}

@Composable
private fun GuideReadActions(
    canManage: Boolean,
    onDownloadPdf: () -> Unit,
    onManageAccess: () -> Unit,
    onEdit: () -> Unit,
) {
    FlowRow(
        modifier = Modifier.fillMaxWidth(),
        horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8, Alignment.End),
        verticalArrangement = Arrangement.spacedBy(AppSpacing.space8),
    ) {
        AppButton(
            text = "Baixar PDF",
            onClick = onDownloadPdf,
            variant = PortalButtonVariant.Outlined,
            leadingIcon = Lucide.Download,
        )
        if (canManage) {
            AppButton(
                text = "Gerenciar perfis",
                onClick = onManageAccess,
                variant = PortalButtonVariant.Secondary,
                leadingIcon = Lucide.Settings,
            )
            AppButton(
                text = "Editar manual",
                onClick = onEdit,
                variant = PortalButtonVariant.Filled,
                leadingIcon = Lucide.Pencil,
            )
        }
    }
}

@Composable
private fun GuideBlocksContent(
    blocks: List<GuideBlock>,
    scrollOffset: Int,
    mediaVisible: Boolean,
) {
    if (blocks.isEmpty()) {
        EmptyState(message = "Este manual ainda não possui conteúdo.")
        return
    }
    blocks.forEach { block ->
        when (block.type) {
            GuideBlockType.TEXT ->
                CompositionLocalProvider(LocalImageLoader provides GuideImageLoader) {
                    RichBody(html = block.html, modifier = Modifier.fillMaxWidth())
                }
            GuideBlockType.IMAGE -> {
                Column(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalAlignment = Alignment.CenterHorizontally,
                    verticalArrangement = Arrangement.spacedBy(AppSpacing.space8),
                ) {
                    GuideMediaImage(
                        documentId = block.documentId,
                        modifier = Modifier.fillMaxWidth().heightIn(max = 520.dp),
                    )
                    GuideCaption(block.caption)
                }
            }
            GuideBlockType.VIDEO -> {
                Column(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalAlignment = Alignment.CenterHorizontally,
                    verticalArrangement = Arrangement.spacedBy(AppSpacing.space8),
                ) {
                    GuideVideoPlayer(
                        documentId = block.documentId,
                        caption = block.caption,
                        scrollOffset = scrollOffset,
                        visible = mediaVisible,
                        modifier = Modifier.fillMaxWidth().height(420.dp),
                    )
                    GuideCaption(block.caption)
                }
            }
            GuideBlockType.PDF ->
                GuidePdfViewer(
                    documentId = block.documentId,
                    fileName = block.fileName,
                    scrollOffset = scrollOffset,
                    visible = mediaVisible,
                    modifier = Modifier.fillMaxWidth().height(620.dp),
                )
        }
    }
}

@Composable
private fun GuideCaption(caption: String) {
    if (caption.isBlank()) return
    Text(
        text = caption,
        style = MaterialTheme.typography.bodySmall,
        color = MaterialTheme.colorScheme.onSurfaceVariant,
        textAlign = TextAlign.Center,
        modifier = Modifier.fillMaxWidth(),
    )
}

@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun ManageAccessDialog(
    controller: GuideDetailController,
    onProfilesSaved: () -> Unit,
) {
    AppModalCard(title = "Gerenciar perfis", onDismiss = controller::dismissAccess) {
        Text(
            text = "Escolha quais perfis podem visualizar este manual.",
            style = MaterialTheme.typography.bodyMedium,
            color = MaterialTheme.colorScheme.onSurfaceVariant,
        )
        FlowRow(
            horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8),
            verticalArrangement = Arrangement.spacedBy(AppSpacing.space8),
        ) {
            FilterChip(
                selected = controller.accessAllRoles,
                onClick = controller::toggleAccessAll,
                label = { Text("Todos") },
            )
            controller.roles.forEach { role ->
                FilterChip(
                    selected = role.id in controller.effectiveAccessRoleIds,
                    onClick = { controller.toggleAccessRole(role.id) },
                    label = { Text(role.name) },
                )
            }
        }
        if (controller.roles.isEmpty()) {
            Text(
                text = "Carregando perfis...",
                style = MaterialTheme.typography.bodySmall,
                color = MaterialTheme.colorScheme.onSurfaceVariant,
            )
        }
        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8, Alignment.End),
        ) {
            AppButton(text = "Cancelar", onClick = controller::dismissAccess, variant = PortalButtonVariant.Text)
            AppButton(
                text = "Salvar perfis",
                onClick = { controller.saveAccess(onProfilesSaved) },
                enabled = !controller.accessSaving,
            )
        }
    }
}

@Composable
private fun BackButtonRow(onBack: () -> Unit) {
    Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.End) {
        AppButton(
            text = "Voltar",
            onClick = onBack,
            variant = PortalButtonVariant.Text,
            leadingIcon = Lucide.ArrowLeft,
        )
    }
}

private enum class SavedToast {
    DRAFT,
    MANUAL,
}

@OptIn(ExperimentalLayoutApi::class)
@Composable
fun GuideFormScreen(
    guideId: String?,
    onBack: () -> Unit,
    onSaved: (String) -> Unit,
    onDraftSaved: (String) -> Unit,
    onDeleted: () -> Unit,
) {
    val controller = rememberGuideFormController(guideId)
    val scrollState = rememberScrollState()
    val textStates = remember(controller) { mutableStateMapOf<String, RichTextState>() }
    var showPublishConfirm by remember { mutableStateOf(false) }
    var showPreview by remember { mutableStateOf(false) }
    var showSaveConfirm by remember { mutableStateOf(false) }
    var successTitle by remember { mutableStateOf<String?>(null) }
    var successGuideId by remember { mutableStateOf<String?>(null) }
    var showDeleteConfirm by remember { mutableStateOf(false) }
    var deleteReady by remember { mutableStateOf(false) }
    var savedToast by remember { mutableStateOf<SavedToast?>(null) }

    LaunchedEffect(controller) { controller.init() }
    LaunchedEffect(savedToast) {
        if (savedToast != null) {
            delay(2500)
            savedToast = null
        }
    }
    LaunchedEffect(deleteReady) {
        if (deleteReady) {
            delay(1500)
            onDeleted()
        }
    }

    Box(modifier = Modifier.fillMaxSize()) {
        AppScrollColumn(
            modifier = Modifier.fillMaxSize(),
            state = scrollState,
            contentPadding = PaddingValues(AppSpacing.space24),
            verticalArrangement = Arrangement.spacedBy(AppSpacing.space16),
            footer = { AppFooter() },
        ) {
            Row(
                modifier = Modifier.fillMaxWidth(),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8),
            ) {
                Row(
                    modifier = Modifier.weight(1f),
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8),
                ) {
                    Text(
                        text = if (controller.isEditing) "Editar manual" else "Novo manual",
                        style = MaterialTheme.typography.headlineMedium,
                    )
                    if (controller.canDeleteDraft) {
                        AppTooltipIconButton(
                            icon = Lucide.Trash2,
                            tooltip = "Excluir rascunho",
                            onClick = { showDeleteConfirm = true },
                            tint = MaterialTheme.colorScheme.error,
                        )
                    }
                }
                AppButton(
                    text = "Voltar",
                    onClick = onBack,
                    variant = PortalButtonVariant.Text,
                    leadingIcon = Lucide.ArrowLeft,
                )
            }
            if (controller.hasPublishedVersion) {
                Text(
                    text = "Cada salvamento cria uma nova versão deste manual.",
                    style = MaterialTheme.typography.labelMedium,
                    color = MaterialTheme.colorScheme.onSurfaceVariant,
                )
            }
            Row(
                modifier = Modifier.fillMaxWidth(),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8, Alignment.End),
            ) {
                if (controller.hasPublishedVersion) {
                    AppButton(
                        text = "Salvar alterações",
                        onClick = { showSaveConfirm = true },
                        enabled = controller.canSave,
                        leadingIcon = Lucide.Check,
                    )
                } else {
                    AppButton(
                        text = "Salvar rascunho",
                        onClick = {
                            controller.save(textHtml(textStates), publish = false) { id ->
                                savedToast = SavedToast.DRAFT
                                onDraftSaved(id)
                            }
                        },
                        enabled = controller.canSave,
                        variant = PortalButtonVariant.Secondary,
                        leadingIcon = Lucide.Pencil,
                    )
                    AppButton(
                        text = "Publicar manual",
                        onClick = { showPublishConfirm = true },
                        enabled = controller.canSave,
                        variant = PortalButtonVariant.Accent,
                        leadingIcon = Lucide.FileText,
                    )
                }
            }
            if (controller.loading) {
                Box(modifier = Modifier.fillMaxWidth().height(200.dp), contentAlignment = Alignment.Center) {
                    CircularProgressIndicator()
                }
            } else {
                GuideFormContent(
                    controller = controller,
                    textStates = textStates,
                    scrollOffset = scrollState.value,
                )
            }
        }
        savedToast?.let { toast ->
            AppToast(
                message = if (toast == SavedToast.MANUAL) Res.string.guides_manual_saved else Res.string.guides_saved,
                modifier = Modifier.align(Alignment.BottomCenter).padding(bottom = AppSpacing.space24),
            )
        }
        if (deleteReady) {
            AppToast(
                message = Res.string.guides_deleted,
                modifier = Modifier.align(Alignment.BottomCenter).padding(bottom = AppSpacing.space24),
            )
        }
    }

    if (showPublishConfirm) {
        PublishGuideDialog(
            title = controller.title,
            version = controller.nextVersion,
            onDismiss = { showPublishConfirm = false },
            onPreview = {
                showPublishConfirm = false
                showPreview = true
            },
            onConfirm = {
                showPublishConfirm = false
                controller.save(textHtml(textStates), publish = true) { id ->
                    successTitle = "Manual publicado com sucesso!"
                    successGuideId = id
                }
            },
        )
    }

    if (showPreview) {
        val previewBlocks =
            controller.blocks.map { block ->
                if (block.type == GuideBlockType.TEXT) {
                    block.copy(html = textStates[block.id]?.toHtml() ?: block.html)
                } else {
                    block
                }
            }
        GuidePreviewDialog(
            title = controller.title,
            description = controller.description,
            blocks = previewBlocks,
            pendingFor = controller::pendingFor,
            onDismiss = { showPreview = false },
            onBack = {
                showPreview = false
                showPublishConfirm = true
            },
            onPublish = {
                showPreview = false
                controller.save(textHtml(textStates), publish = true) { id ->
                    successTitle = "Manual publicado com sucesso!"
                    successGuideId = id
                }
            },
        )
    }

    if (showSaveConfirm) {
        AppModalCard(title = "Salvar alterações", onDismiss = { showSaveConfirm = false }) {
            Text(
                text = "Deseja salvar as alterações? Será criada a versão v${controller.nextVersion} deste manual.",
                style = MaterialTheme.typography.bodyMedium,
                color = MaterialTheme.colorScheme.onSurfaceVariant,
            )
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8, Alignment.End),
            ) {
                AppButton(
                    text = "Cancelar",
                    onClick = { showSaveConfirm = false },
                    variant = PortalButtonVariant.Text,
                )
                AppButton(
                    text = "Salvar alterações",
                    onClick = {
                        showSaveConfirm = false
                        controller.save(textHtml(textStates), publish = false) { id ->
                            successTitle =
                                "A versão ${controller.version ?: controller.nextVersion} do manual foi publicada com sucesso"
                            successGuideId = id
                        }
                    },
                    enabled = controller.canSave,
                    leadingIcon = Lucide.Check,
                )
            }
        }
    }

    successTitle?.let { title ->
        SuccessDialog(
            title = title,
            onDismiss = {
                successTitle = null
                successGuideId?.let(onSaved)
                successGuideId = null
            },
        )
    }

    if (showDeleteConfirm) {
        AppModalCard(title = "Excluir rascunho", onDismiss = { showDeleteConfirm = false }) {
            Text(
                text = "Deseja excluir o rascunho \"${controller.title}\"? Essa ação não pode ser desfeita.",
                style = MaterialTheme.typography.bodyMedium,
                color = MaterialTheme.colorScheme.onSurfaceVariant,
            )
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8, Alignment.End),
            ) {
                AppButton(
                    text = "Cancelar",
                    onClick = { showDeleteConfirm = false },
                    variant = PortalButtonVariant.Text,
                )
                AppButton(
                    text = "Excluir",
                    onClick = {
                        controller.deleteDraft {
                            showDeleteConfirm = false
                            deleteReady = true
                        }
                    },
                    enabled = !controller.deleting,
                    variant = PortalButtonVariant.Danger,
                )
            }
        }
    }
}

private fun textHtml(states: Map<String, RichTextState>): Map<String, String> = states.mapValues { it.value.toHtml() }

@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun GuideFormContent(
    controller: GuideFormController,
    textStates: MutableMap<String, RichTextState>,
    scrollOffset: Int,
) {
    controller.errorMessage?.let { message ->
        AppBanner(text = message, onDismiss = {}, isError = true)
    }

    Surface(
        modifier = Modifier.fillMaxWidth(),
        shape = AppShapes.large,
        color = MaterialTheme.colorScheme.surface,
        border = BorderStroke(1.dp, MaterialTheme.colorScheme.outlineVariant),
    ) {
        Column(
            modifier = Modifier.fillMaxWidth().padding(AppSpacing.space16),
            verticalArrangement = Arrangement.spacedBy(AppSpacing.space12),
        ) {
            AppTextField(
                value = controller.title,
                onValueChange = controller::updateTitle,
                placeholder = "Digite o título do manual",
                modifier = Modifier.fillMaxWidth(),
            )
            AppTextField(
                value = controller.description,
                onValueChange = controller::updateDescription,
                placeholder = "Descreva o conteúdo do manual",
                singleLine = false,
                modifier = Modifier.fillMaxWidth().heightIn(min = 80.dp),
            )
            Text(
                text = "${controller.description.length}/350 caracteres",
                style = MaterialTheme.typography.labelSmall,
                color = MaterialTheme.colorScheme.onSurfaceVariant,
            )
            Text(text = "Perfis com acesso", style = MaterialTheme.typography.titleSmall)
            Text(
                text = "Marque os perfis que terão acesso a este manual.",
                style = MaterialTheme.typography.bodySmall,
                color = MaterialTheme.colorScheme.onSurfaceVariant,
            )
            FlowRow(
                horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8),
                verticalArrangement = Arrangement.spacedBy(AppSpacing.space8),
            ) {
                FilterChip(
                    selected = controller.allRoles,
                    onClick = controller::toggleAll,
                    label = { Text("Todos") },
                )
                controller.roles.forEach { role ->
                    FilterChip(
                        selected = role.id in controller.effectiveSelectedRoles,
                        onClick = { controller.toggleRole(role.id) },
                        label = { Text(role.name) },
                    )
                }
            }
        }
    }

    Column(verticalArrangement = Arrangement.spacedBy(AppSpacing.space12)) {
        controller.blocks.forEachIndexed { index, block ->
            key(block.id) {
                GuideBlockEditor(
                    block = block,
                    index = index,
                    blockCount = controller.blocks.size,
                    controller = controller,
                    textStates = textStates,
                    scrollOffset = scrollOffset,
                )
            }
        }
    }

    AddBlockMenu(onAdd = controller::addBlock)
}

@Composable
private fun AddBlockMenu(onAdd: (GuideBlockType) -> Unit) {
    var expanded by remember { mutableStateOf(false) }
    Box {
        Row(
            modifier = Modifier.clickable { expanded = true }.padding(vertical = AppSpacing.space8),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8),
        ) {
            Icon(imageVector = Lucide.Plus, contentDescription = null, tint = MaterialTheme.colorScheme.primary)
            Text(
                text = "Adicionar",
                style = MaterialTheme.typography.labelLarge,
                color = MaterialTheme.colorScheme.primary,
            )
            Icon(
                imageVector = Lucide.ChevronDown,
                contentDescription = null,
                tint = MaterialTheme.colorScheme.primary,
                modifier = Modifier.size(18.dp),
            )
        }
        DropdownMenu(expanded = expanded, onDismissRequest = { expanded = false }) {
            GuideBlockType.entries.forEach { type ->
                DropdownMenuItem(
                    text = { Text(blockTypeLabel(type)) },
                    leadingIcon = { Icon(imageVector = blockTypeIcon(type), contentDescription = null) },
                    onClick = {
                        expanded = false
                        onAdd(type)
                    },
                )
            }
        }
    }
}

@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun GuideBlockEditor(
    block: GuideBlock,
    index: Int,
    blockCount: Int,
    controller: GuideFormController,
    textStates: MutableMap<String, RichTextState>,
    scrollOffset: Int,
) {
    Surface(
        modifier = Modifier.fillMaxWidth(),
        shape = AppShapes.large,
        color = MaterialTheme.colorScheme.surface,
        border = BorderStroke(1.dp, MaterialTheme.colorScheme.outlineVariant),
    ) {
        Column(
            modifier = Modifier.fillMaxWidth().padding(AppSpacing.space16),
            verticalArrangement = Arrangement.spacedBy(AppSpacing.space12),
        ) {
            Row(
                modifier = Modifier.fillMaxWidth(),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8),
            ) {
                Icon(imageVector = blockTypeIcon(block.type), contentDescription = null, modifier = Modifier.size(20.dp))
                Text(
                    text = blockTypeLabel(block.type),
                    style = MaterialTheme.typography.titleSmall,
                    modifier = Modifier.weight(1f),
                )
                AppTooltipIconButton(
                    icon = Lucide.ArrowUp,
                    tooltip = "Mover para cima",
                    onClick = { controller.moveBlock(block.id, -1) },
                    enabled = index > 0,
                )
                AppTooltipIconButton(
                    icon = Lucide.ArrowDown,
                    tooltip = "Mover para baixo",
                    onClick = { controller.moveBlock(block.id, 1) },
                    enabled = index < blockCount - 1,
                )
                AppTooltipIconButton(
                    icon = Lucide.Trash2,
                    tooltip = "Remover seção",
                    onClick = { controller.removeBlock(block.id) },
                    tint = MaterialTheme.colorScheme.error,
                )
            }
            when (block.type) {
                GuideBlockType.TEXT ->
                    GuideTextBlockEditor(
                        block = block,
                        textStates = textStates,
                    )
                GuideBlockType.IMAGE ->
                    GuideMediaBlockEditor(
                        block = block,
                        controller = controller,
                        scrollOffset = scrollOffset,
                    )
                GuideBlockType.VIDEO ->
                    GuideMediaBlockEditor(
                        block = block,
                        controller = controller,
                        scrollOffset = scrollOffset,
                    )
                GuideBlockType.PDF ->
                    GuideMediaBlockEditor(
                        block = block,
                        controller = controller,
                        scrollOffset = scrollOffset,
                    )
            }
        }
    }
}

@OptIn(ExperimentalLayoutApi::class, ExperimentalMaterial3Api::class)
@Composable
private fun GuideTextBlockEditor(
    block: GuideBlock,
    textStates: MutableMap<String, RichTextState>,
) {
    val richState = rememberRichTextState()
    LaunchedEffect(block.id) {
        if (block.html.isNotBlank()) {
            runCatching { richState.setHtml(block.html) }
        }
    }
    SideEffect { textStates[block.id] = richState }

    RichTextToolbar(state = richState)
    CompositionLocalProvider(LocalImageLoader provides GuideImageLoader) {
        Surface(
            shape = AppShapes.medium,
            color = Color.White,
            border = BorderStroke(1.dp, MaterialTheme.colorScheme.outlineVariant),
        ) {
            RichTextEditor(
                state = richState,
                colors = RichTextEditorDefaults.richTextEditorColors(containerColor = Color.White),
                modifier = Modifier.fillMaxWidth().heightIn(min = 180.dp).padding(AppSpacing.space12),
            )
        }
    }
}

@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun GuideMediaBlockEditor(
    block: GuideBlock,
    controller: GuideFormController,
    scrollOffset: Int,
) {
    val scope = rememberCoroutineScope()
    val supported = mediaUploadSupported(block.type)
    val pending = controller.pendingFor(block.id)
    var previewOpen by remember(block.id) { mutableStateOf(false) }
    val hasMedia = block.documentId.isNotBlank() || pending != null

    if (!hasMedia) {
        Surface(
            modifier = Modifier.fillMaxWidth().height(160.dp),
            shape = AppShapes.medium,
            color = AppPalette.Neutral50,
            border = BorderStroke(1.dp, MaterialTheme.colorScheme.outlineVariant),
        ) {
            Column(
                modifier = Modifier.fillMaxSize().padding(AppSpacing.space16),
                verticalArrangement = Arrangement.Center,
                horizontalAlignment = Alignment.CenterHorizontally,
            ) {
                Text(
                    text = "Nenhum arquivo selecionado",
                    style = MaterialTheme.typography.bodyMedium,
                    color = MaterialTheme.colorScheme.onSurfaceVariant,
                )
                AppButton(
                    text = if (supported) "Selecionar arquivo" else "Disponível na versão Web",
                    onClick = {
                        if (!supported) return@AppButton
                        scope.launch { pickMedia(block, controller) }
                    },
                    enabled = supported,
                    variant = PortalButtonVariant.Outlined,
                )
            }
        }
        return
    }

    when (block.type) {
        GuideBlockType.IMAGE ->
            if (pending != null) {
                PendingGuideImage(
                    bytes = pending.bytes,
                    modifier = Modifier.fillMaxWidth().heightIn(max = 360.dp),
                )
            } else {
                GuideMediaImage(
                    documentId = block.documentId,
                    modifier = Modifier.fillMaxWidth().heightIn(max = 360.dp),
                )
            }
        GuideBlockType.VIDEO,
        GuideBlockType.PDF,
        ->
            GuideAttachmentCard(
                block = block,
                displayName = pending?.fileName ?: block.fileName,
                isPending = pending != null,
                onOpen = { previewOpen = true },
            )
        GuideBlockType.TEXT -> Unit
    }

    if (block.type == GuideBlockType.IMAGE || block.type == GuideBlockType.VIDEO) {
        AppTextField(
            value = block.caption,
            onValueChange = { controller.updateCaption(block.id, it) },
            label = "Legenda (opcional)",
            singleLine = false,
            modifier = Modifier.fillMaxWidth(),
        )
    }
    if (block.type == GuideBlockType.PDF && (pending?.fileName ?: block.fileName).isNotBlank()) {
        Text(
            text = pending?.fileName ?: block.fileName,
            style = MaterialTheme.typography.labelMedium,
            color = MaterialTheme.colorScheme.onSurfaceVariant,
        )
    }
    if (supported) {
        AppButton(
            text = "Trocar arquivo",
            onClick = { scope.launch { pickMedia(block, controller) } },
            variant = PortalButtonVariant.Text,
        )
    }

    if (previewOpen && (block.type == GuideBlockType.VIDEO || block.type == GuideBlockType.PDF)) {
        AppModalCard(
            title = if (block.type == GuideBlockType.VIDEO) "Vídeo" else "PDF",
            onDismiss = { previewOpen = false },
            wide = true,
        ) {
            val currentPending = controller.pendingFor(block.id)
            if (currentPending != null) {
                if (block.type == GuideBlockType.VIDEO) {
                    PendingVideoPlayer(
                        media = currentPending,
                        caption = block.caption,
                        scrollOffset = scrollOffset,
                        modifier = Modifier.fillMaxWidth().height(520.dp),
                    )
                } else {
                    PendingPdfViewer(
                        media = currentPending,
                        scrollOffset = scrollOffset,
                        modifier = Modifier.fillMaxWidth().height(620.dp),
                    )
                }
            } else if (block.type == GuideBlockType.VIDEO) {
                GuideVideoPlayer(
                    documentId = block.documentId,
                    caption = block.caption,
                    scrollOffset = scrollOffset,
                    modifier = Modifier.fillMaxWidth().height(520.dp),
                )
            } else {
                GuidePdfViewer(
                    documentId = block.documentId,
                    fileName = block.fileName,
                    scrollOffset = scrollOffset,
                    modifier = Modifier.fillMaxWidth().height(620.dp),
                )
            }
        }
    }
}

@Composable
private fun GuideAttachmentCard(
    block: GuideBlock,
    displayName: String,
    isPending: Boolean,
    onOpen: () -> Unit,
) {
    Surface(
        modifier = Modifier.fillMaxWidth(),
        shape = AppShapes.medium,
        color = AppPalette.Neutral50,
        border = BorderStroke(1.dp, MaterialTheme.colorScheme.outlineVariant),
    ) {
        Row(
            modifier = Modifier.fillMaxWidth().padding(AppSpacing.space16),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(AppSpacing.space12),
        ) {
            Icon(
                imageVector = blockTypeIcon(block.type),
                contentDescription = null,
                tint = MaterialTheme.colorScheme.primary,
                modifier = Modifier.size(28.dp),
            )
            Column(modifier = Modifier.weight(1f), verticalArrangement = Arrangement.spacedBy(AppSpacing.space4)) {
                val label =
                    displayName.ifBlank {
                        if (block.type == GuideBlockType.VIDEO) "Vídeo anexado" else "PDF anexado"
                    }
                Text(
                    text = label,
                    style = MaterialTheme.typography.bodyMedium,
                    fontWeight = FontWeight.SemiBold,
                )
                Text(
                    text = if (isPending) "Será enviado ao salvar" else "Visualização disponível na versão Web",
                    style = MaterialTheme.typography.labelSmall,
                    color = MaterialTheme.colorScheme.onSurfaceVariant,
                )
            }
            AppButton(
                text = "Visualizar",
                onClick = onOpen,
                variant = PortalButtonVariant.Outlined,
            )
        }
    }
}

private suspend fun pickMedia(
    block: GuideBlock,
    controller: GuideFormController,
) {
    when (block.type) {
        GuideBlockType.IMAGE -> {
            pickImageFile()?.let { file ->
                val extension = if (file.contentType.equals("image/png", ignoreCase = true)) "png" else "jpg"
                controller.stageMedia(block.id, file.bytes, file.contentType, "imagem.$extension")
            }
        }
        GuideBlockType.VIDEO -> {
            pickVideoFile()?.let { file ->
                controller.stageMedia(block.id, file.bytes, file.contentType, file.name)
            }
        }
        GuideBlockType.PDF -> {
            pickPdfFile()?.let { file ->
                controller.stageMedia(block.id, file.bytes, file.contentType, file.name)
            }
        }
        GuideBlockType.TEXT -> Unit
    }
}

private fun mediaUploadSupported(type: GuideBlockType): Boolean =
    when (type) {
        GuideBlockType.IMAGE -> isImageUploadSupported()
        GuideBlockType.VIDEO -> isVideoUploadSupported()
        GuideBlockType.PDF -> isPdfUploadSupported()
        GuideBlockType.TEXT -> false
    }

@Composable
private fun PublishGuideDialog(
    title: String,
    version: Int,
    onDismiss: () -> Unit,
    onPreview: () -> Unit,
    onConfirm: () -> Unit,
) {
    AppModalCard(title = "Publicar manual", onDismiss = onDismiss) {
        Text(
            text = "Deseja publicar \"$title\"? Será criada a versão v$version.",
            style = MaterialTheme.typography.bodyMedium,
            color = MaterialTheme.colorScheme.onSurfaceVariant,
        )
        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8, Alignment.End),
        ) {
            AppButton(text = "Cancelar", onClick = onDismiss, variant = PortalButtonVariant.Text)
            AppButton(text = "Pré-visualizar", onClick = onPreview, variant = PortalButtonVariant.Outlined)
            AppButton(text = "Publicar", onClick = onConfirm, variant = PortalButtonVariant.Accent)
        }
    }
}

@Composable
private fun GuidePreviewDialog(
    title: String,
    description: String,
    blocks: List<GuideBlock>,
    pendingFor: (String) -> PendingGuideMedia?,
    onDismiss: () -> Unit,
    onBack: () -> Unit,
    onPublish: () -> Unit,
) {
    AppModalCard(title = "Pré-visualização do manual", onDismiss = onDismiss, wide = true) {
        Text(text = title, style = MaterialTheme.typography.headlineSmall)
        if (description.isNotBlank()) {
            Text(
                text = description,
                style = MaterialTheme.typography.bodyMedium,
                color = MaterialTheme.colorScheme.onSurfaceVariant,
            )
        }
        Column(verticalArrangement = Arrangement.spacedBy(AppSpacing.space16)) {
            blocks.forEach { block ->
                when (block.type) {
                    GuideBlockType.TEXT ->
                        CompositionLocalProvider(LocalImageLoader provides GuideImageLoader) {
                            RichBody(html = block.html, modifier = Modifier.fillMaxWidth())
                        }
                    GuideBlockType.IMAGE -> {
                        val pending = pendingFor(block.id)
                        Column(
                            modifier = Modifier.fillMaxWidth(),
                            horizontalAlignment = Alignment.CenterHorizontally,
                            verticalArrangement = Arrangement.spacedBy(AppSpacing.space8),
                        ) {
                            if (pending != null) {
                                PendingGuideImage(
                                    bytes = pending.bytes,
                                    modifier = Modifier.fillMaxWidth().heightIn(max = 360.dp),
                                )
                            } else {
                                GuideMediaImage(
                                    documentId = block.documentId,
                                    modifier = Modifier.fillMaxWidth().heightIn(max = 360.dp),
                                )
                            }
                            GuideCaption(block.caption)
                        }
                    }
                    GuideBlockType.VIDEO,
                    GuideBlockType.PDF,
                    ->
                        PreviewAttachmentBlock(block = block, pending = pendingFor(block.id))
                }
            }
        }
        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8, Alignment.End),
        ) {
            AppButton(text = "Voltar", onClick = onBack, variant = PortalButtonVariant.Text)
            AppButton(text = "Publicar", onClick = onPublish, variant = PortalButtonVariant.Accent)
        }
    }
}

@Composable
private fun PreviewAttachmentBlock(
    block: GuideBlock,
    pending: PendingGuideMedia?,
) {
    Surface(
        modifier = Modifier.fillMaxWidth(),
        shape = AppShapes.medium,
        color = AppPalette.Neutral50,
        border = BorderStroke(1.dp, MaterialTheme.colorScheme.outlineVariant),
    ) {
        Row(
            modifier = Modifier.fillMaxWidth().padding(AppSpacing.space16),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(AppSpacing.space12),
        ) {
            Icon(
                imageVector = blockTypeIcon(block.type),
                contentDescription = null,
                tint = MaterialTheme.colorScheme.primary,
                modifier = Modifier.size(28.dp),
            )
            Column(modifier = Modifier.weight(1f), verticalArrangement = Arrangement.spacedBy(AppSpacing.space4)) {
                Text(
                    text = pending?.fileName ?: block.fileName.ifBlank { blockTypeLabel(block.type) },
                    style = MaterialTheme.typography.bodyMedium,
                    fontWeight = FontWeight.SemiBold,
                )
                Text(
                    text = if (block.type == GuideBlockType.VIDEO) "Vídeo anexado" else "PDF anexado",
                    style = MaterialTheme.typography.labelSmall,
                    color = MaterialTheme.colorScheme.onSurfaceVariant,
                )
            }
        }
    }
}

private fun typeIcon(type: GuideContentType) =
    when (type) {
        GuideContentType.VIDEO -> Lucide.Play
        GuideContentType.PDF -> Lucide.FileText
        else -> Lucide.TextAlignStart
    }

private fun typeColor(type: GuideContentType) =
    when (type) {
        GuideContentType.VIDEO -> AppPalette.Purple500
        GuideContentType.PDF -> AppPalette.Warning500
        else -> AppPalette.Info500
    }

private fun typeBackground(type: GuideContentType) =
    when (type) {
        GuideContentType.VIDEO -> AppPalette.Purple100
        GuideContentType.PDF -> AppPalette.Warning100
        else -> AppPalette.Info100
    }

private fun blockTypeIcon(type: GuideBlockType) =
    when (type) {
        GuideBlockType.TEXT -> Lucide.List
        GuideBlockType.IMAGE -> Lucide.Image
        GuideBlockType.VIDEO -> Lucide.Video
        GuideBlockType.PDF -> Lucide.Paperclip
    }

private fun blockTypeLabel(type: GuideBlockType): String =
    when (type) {
        GuideBlockType.TEXT -> "Bloco de texto"
        GuideBlockType.IMAGE -> "Imagem"
        GuideBlockType.VIDEO -> "Vídeo"
        GuideBlockType.PDF -> "PDF"
    }

@Composable
private fun rememberGuidePdfAssets(): () -> GuidePdfAssets {
    val logoPortal = painterResource(Res.drawable.logo_portal)
    val logoVv = painterResource(Res.drawable.logo_vv)
    val videoIcon = rememberVectorPainter(Lucide.Play)
    val pdfIcon = rememberVectorPainter(Lucide.FileText)
    return remember(logoPortal, logoVv, videoIcon, pdfIcon) {
        {
            GuidePdfAssets(
                logoPortal = logoPortal.toPdfImage(widthPx = 316, heightPx = 77),
                logoVv = logoVv.toPdfImage(widthPx = 312, heightPx = 58),
                videoIcon = videoIcon.toPdfImage(widthPx = 64, heightPx = 64),
                pdfIcon = pdfIcon.toPdfImage(widthPx = 64, heightPx = 64),
            )
        }
    }
}
